import React from 'react';
import IconHelper from '@bazooka_se/lf-icons';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {getEpiData} from '../../Utils/epiHelpers';
import RawHtml from '../../UI/RawHtml';

import Loader from '../../UI/Loader';
import ErrorMessage from '../../UI/ErrorMessage';
import Notice, {NOTICE_TYPE_SUCCESS, NOTICE_TYPE_FAILURE} from './Components/Notice';

import {submitStudentInsuranceForm, loadStudentInsuranceTeaserDataAction, studentInsuranceTeaserFormSubmitFailureAction} from './State/actions';


import BankingForm from './Forms/BankingForm';
import InvoiceForm from './Forms/InvoiceForm';
import definitions from '../../Style/LfStyleDefinitions';

const INVOICE_FORM = 0;
const BANKING_FORM = 1;

class ExtendStudentInsuranceTeaser extends React.Component {
    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    constructor(props) {
        super(props);
        this.heading = getEpiData('heading', this.props.mountRootId) || '';
        this.preamble = getEpiData('preamble', this.props.mountRootId) || '';
        this.image = getEpiData('image', this.props.mountRootId) || false;
        this.customerServiceUrl = getEpiData('customer-service-url', this.props.mountRootId) || false;
        this.myInsurancesUrl = getEpiData('my-insurances-url', this.props.mountRootId) || false;
        this.termsAndConditionsUrl = getEpiData('product-page-url', this.props.mountRootId) || false;
        this.insuranceName = getEpiData('insurance-name', this.props.mountRootId) || false;

        this.invoiceForm = React.createRef();
        this.bankingForm = React.createRef();
    }

    componentDidMount() {
        this.props.loadData();
    }

    stripFormNamesFromSharedVars(formValues) {
        const sharedVars = [
            "IsFullyAbleToWork",
            "PurchaseTermsApproved"
        ];

        let newObject = {};
        let keysToRemove = [];

        Object.keys(formValues).forEach(key => {
            sharedVars.forEach(sharedVar => {
                if (key.indexOf(sharedVar) == 0) {
                    newObject[sharedVar] = formValues[key];
                    keysToRemove.push(key);
                }
            });
        });

        Object.keys(newObject).forEach(key => {
            formValues[key] = newObject[key];
        });

        keysToRemove.forEach(key => {
            delete formValues[key];
        });

        return formValues;
    }

    formSubmit(formId, formValues) {
        formValues = this.stripFormNamesFromSharedVars(formValues);
        formValues.insurancename = this.insuranceName;

        switch(formId) {
            case BANKING_FORM:
                this.props.submitStudentInsuranceForm(formValues, true);
                break;
            case INVOICE_FORM:
                this.props.submitStudentInsuranceForm(formValues, false);
                break;
        }
    }

    isFormOpen(element) {
        return element.getAttribute('data-lf-accordion-open');
    }

    formHeaderClick(clickedForm) {
        const paymentMethodIsAutomatic = this.props.data.paymentMethod == 'Autogiro';

        if(paymentMethodIsAutomatic) {
            return;
        }

        setTimeout(() => {
            if (clickedForm.getAttribute('data-lf-accordion-open')) {
                const fakeClick = new MouseEvent('click',{
                        view: window,
                        bubbles: true,
                        cancelable: true
                    }
                );

                if (clickedForm == this.invoiceForm.current && this.isFormOpen(this.bankingForm.current)) {
                    this.bankingForm.current.querySelector('a[data-lf-accordion]').dispatchEvent(fakeClick);
                } else if (clickedForm == this.bankingForm.current && this.isFormOpen(this.invoiceForm.current)) {
                    // haxx time: when automatically closing this form, the window scrolls away too much which we do not want
                    const heightOffset = this.bankingForm.current.offsetTop;

                    try {
                        window.scrollTo({
                            left: 0,
                            top: heightOffset,
                            behavior: "smooth"
                        });
                    } catch (e) {
                        window.scrollTo(0, heightOffset);
                    }

                    this.invoiceForm.current.querySelector('a[data-lf-accordion]').dispatchEvent(fakeClick);
                }
            }
        }, 100);
    }

    render() {
        const formSubmitFailed = this.props.data.formSubmitFailed;
        const formSubmitSuccess = this.props.data.formSubmitted;
        const automaticForm = this.props.data.automaticForm;
        const paymentMethodIsAutomatic = this.props.data.paymentMethod == 'Autogiro';

        let content = (
            <div>
                { !paymentMethodIsAutomatic && <div className="extend-student-insurance-teaser__content__spacer" /> }
                <InvoiceForm
                    domRef={this.invoiceForm}
                    showHeader={!paymentMethodIsAutomatic}
                    onFormHeaderClick={ e => { this.formHeaderClick(this.invoiceForm.current) } }
                    termsAndConditionsUrl={this.termsAndConditionsUrl}
                    onSubmit={(formValues) => { this.formSubmit(INVOICE_FORM, formValues); }}
                />
                {/*Code for atuopayment student, may be used in the future*/}
                {/*{ !paymentMethodIsAutomatic && (*/}
                {/*    <div>*/}
                {/*        <div className="extend-student-insurance-teaser__content__spacer" />*/}
                {/*        <BankingForm*/}
                {/*            domRef={this.bankingForm}*/}
                {/*            showHeader*/}
                {/*            onFormHeaderClick={ e => { this.formHeaderClick(this.bankingForm.current) } }*/}
                {/*            termsAndConditionsUrl={this.termsAndConditionsUrl}*/}
                {/*            onSubmit={(formValues) => { this.formSubmit(BANKING_FORM, formValues); }}*/}
                {/*        />*/}
                {/*        <div className="extend-student-insurance-teaser__content__spacer" />*/}
                {/*    </div>*/}
                {/*)}*/}
            </div>
        );

        if(this.props.isLoading) {
            content = (<Loader color={definitions.colors.blueBackground}/>);
        }

        if(this.props.hasErrored) {
            content = (<ErrorMessage message={`Ooops! Ett fel har uppstått: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message }`} />);
        }
        if(formSubmitFailed) {
            content = (
                <Notice
                    type={NOTICE_TYPE_FAILURE}
                    description={<p>Något gick fel och din förlängning har inte genomförts. Om problemet kvartstår kan du <br/><a href={this.customerServiceUrl}>kontakta kundtjänst</a>.</p>}
                    onRetryClick={() => {
                        this.props.resetFormSubmitFailure();
                    }}
                />
                );
        }
        if(formSubmitSuccess) {
            content = (
                <Notice
                    type={NOTICE_TYPE_SUCCESS}
                    description={(
                        automaticForm == true || paymentMethodIsAutomatic  ? <p>
                            Tack! Din förlängning har mottagits. Du ser dina försäkringar på <br/><a href={this.myInsurancesUrl}>Mina försäkringar</a>.
                        </p> :
                        <>
                            <p className="extend-student-insurance-notice__first-paragraph">
                                Tack! Din förlängning har mottagits. Du kommer få ett inbetalningskort med posten. Om du vill slippa pappersfakturor kan du istället välja autogiro.
                            </p>

                            <a href="https://www.mypayex.com/application/direct-debit-sign-up-se/24416/register" target="_blank" className="button button--green button--external-link">Betala med autogiro<span className="extend-student-insurance-notice__link-icon"
                                dangerouslySetInnerHTML={{ __html: IconHelper('external-link').outerHTML }}>
                            </span></a>

                            <p className="extend-student-insurance-notice__last-paragraph">
                                    Du ser dina försäkringar på <br /><a href={this.myInsurancesUrl}>Mina försäkringar</a>.
                            </p>
                        </>
                    )}
                />
            );
        }

        return (
            <div className="extend-student-insurance-teaser">
                <div className="extend-student-insurance-teaser__header">
                    <div className="extend-student-insurance-teaser__header__content">
                        <h3 className="extend-student-insurance-teaser__header__content__title"><RawHtml>{this.heading}</RawHtml></h3>
                        <div className="extend-student-insurance-teaser__header__content__description">
                            <RawHtml>{this.preamble}</RawHtml>
                        </div>

                    </div>
                    {this.image && (
                        <div className="extend-student-insurance-teaser__header__image">
                            <img className="extend-student-insurance-teaser__header__image__img" src={this.image} />
                        </div>
                    )}
                </div>
                <div className="extend-student-insurance-teaser__content">
                    {content}
                </div>
            </div>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.extendStudentInsuranceTeaserData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(loadStudentInsuranceTeaserDataAction()),
        resetFormSubmitFailure: () => dispatch(studentInsuranceTeaserFormSubmitFailureAction(false)),
        submitStudentInsuranceForm: (data) => dispatch(submitStudentInsuranceForm(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtendStudentInsuranceTeaser);